document.addEventListener('DOMContentLoaded', function () {
  const guideTable = document.querySelector('.size-guide-table');

  if (guideTable) {
    const children = Array.from(guideTable.children);
    const paragraphs = guideTable.querySelectorAll('p');
    paragraphs && paragraphs.forEach(paragraph => {
      if (paragraph.innerHTML === "&nbsp;") {
        paragraph.style.display = "none";
      }
    });

    let wrapper = null;
    let tableTextDiv = null;

    children.forEach((child, index) => {
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.classList.add('table-wrapper');
        tableTextDiv = document.createElement('div');
        tableTextDiv.classList.add('table-text');
      }

      if (child.tagName !== 'TABLE') {
        tableTextDiv.appendChild(child);
      } else {
        sizeGuideTableWrapper = document.createElement('div');
        sizeGuideTableWrapper.classList.add('size-guide-table-wrapper');

        wrapper.appendChild(tableTextDiv);
        sizeGuideTableWrapper.appendChild(child);
        wrapper.appendChild(sizeGuideTableWrapper);

        guideTable.insertBefore(wrapper, child.nextElementSibling);
        wrapper = null;
        tableTextDiv = null;

      }
    });

    if (wrapper && wrapper.children.length > 0) {
      wrapper.appendChild(tableTextDiv);
      guideTable.appendChild(wrapper);
    }
  }
});

